const required = value => (value ? undefined : 'Required');

export default required;